import React, { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';

// The frame of the public pages (landing, legal documents, contact): the main menu on top and the footer at the bottom STAY on screen while
// the visitor moves between these pages — only the body in the middle changes. (Each page used to draw its own menu and footer, so a click on a
// tab removed the whole page, showed the loader and drew everything again.) A page that is still loading shows a quiet empty body, not the full-screen loader.
const BG = '#f7f2ea';

export default function SiteShell({ children }) {
  const { pathname, hash } = useLocation();

  // a menu item like /#pricing from another page: scroll to the section once its page has drawn; a new page without a hash starts at the top
  useEffect(() => {
    if (!hash) { if (pathname !== '/') window.scrollTo({ top: 0 }); return undefined; }
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      tries += 1;
      if (el) { el.scrollIntoView(); clearInterval(t); } else if (tries > 20) clearInterval(t);
    }, 100);
    return () => clearInterval(t);
  }, [pathname, hash]);

  const active = pathname === '/' ? 'auto' : pathname === '/contact' ? 'Contact' : '';
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', background: BG, fontFamily: "'Poppins',sans-serif", display: 'flex', flexDirection: 'column' }}>
      <LandingNav active={active} />
      <Box sx={{ flex: 1 }}>
        <Suspense fallback={<Box sx={{ minHeight: '60vh' }} />}>{children}</Suspense>
      </Box>
      <LandingFooter />
    </Box>
  );
}
